import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { Ndc9ProdForm } from '@/md/entities/ndc9Prod/Ndc9ProdForm';
import { ProdEligList } from '@/md/entities/prodElig/ProdEligList';
import { ProdIdentList } from '@/md/entities/prodIdent/ProdIdentList';
import { ProdPriceList } from '@/md/entities/prodPrice/ProdPriceList';
import { ProdRelList } from '@/md/entities/prodRel/ProdRelList';
import { useCallback } from 'react';
import { Ndc11ProdForm } from './Ndc11ProdForm';

export const Ndc11ProdDetail = () => {

  const { entityObj } = useEntityMgr();
  const augRowsReq = useCallback(
    EntityUtils.parentFilterAugRowsReq('NDC11_PROD', entityObj.id),
    [entityObj.id]
  )

  // --- Tab Specifications --- 
  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: <Ndc11ProdForm /> }];
  if (entityObj.ndc9ProdId) {
    tabSpecs.push({ id: 'ndc9Tab', label: 'NDC9', content: <Ndc9ProdForm entityId={entityObj.ndc9ProdId} /> });
  }
  if (entityObj.id) {
    tabSpecs.push(
      { id: 'prodElig', label: 'Eligibility', content: <ProdEligList ndc11ProdId={entityObj.id} /> },
      { id: 'prodIdent', label: 'Identifiers', content: <ProdIdentList ndc11ProdId={entityObj.id} /> },
      { id: 'prodPrice', label: 'Prices', content: <ProdPriceList ndc11ProdId={entityObj.id} /> },
      { id: 'prodRel', label: 'Relationships', content: <ProdRelList ndc11ProdId={entityObj.id} /> },
      { id: 'prop', label: 'Properties', content: <EntityPropList parentEntity="NDC11_PROD" parentEntityObj={entityObj} /> },
      { id: 'ndc11ProdLowDispensablePkgSize', label: 'Medicaid Lowest Disp. Pkg. Size', content: <EntityList entity="NDC11_PROD_LOW_DISPENSABLE_PKG_SIZE" augRowsReq={augRowsReq} /> },
      { id: 'ndc11ProdUnitThreshold', label: 'Medicaid Unit Threshold', content: <EntityList entity="NDC11_PROD_UNIT_THRESHOLD" augRowsReq={augRowsReq} /> }
    );
  }

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}